// ** Initial State
const initialState = {
    category: [], subCategory: [], exam: [], batchProcess: [], subscriptionPlans: [], coupanCodes: [], configs: [],
    level: [{ id: 1, name: 'Easy' }, { id: 2, name: 'Medium' }, { id: 3, name: 'Hard' }],
    type: [{ id: 1, name: 'Full Length' }, { id: 2, name: 'Sectional Test' }, { id: 3, name: 'Miscellaneous Test' }, { id: 4, name: 'BookmarkQues Test' }, { id: 5, name: 'SWOT Test' }, { id: 6, name: 'Dynamic Test' }],
    testSeries: [], tests: [], testSeriesSubscriptions: [], testPurchase: [], dynamicTests: [], examsCovered: [], previousYearTests: [], bookmarkedTests: [],
    profile: {},
    liveTests: [],
    liveTestStats: {},
    loadingLiveTests: false,
    errorLiveTests: null,
    // Attempted tests data
    attemptedTests: [],
    attemptedTestsLoading: false,
    attemptedTestsError: null,
    // Test analysis data
    testAnalysis: null,
    testAnalysisLoading: false,
    testAnalysisError: null,
    // Home page data with caching
    homeTestSeries: [],
    homeExamsCovered: [],
    homeDataLoading: false,
    homeDataError: null,
    homeDataLastFetched: null,
    // stats: {}
}

const questionReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_CATEGORY':
            return {
                ...state,
                category: action.data,
            }
        case 'GET_SUBCATEGORY':
            return {
                ...state,
                subCategory: action.data
            }
        case 'GET_LEVEL':
            return {
                ...state,
                level: action.data
            }
        case 'GET_EXAM':
            return {
                ...state,
                exam: action.data
            }
        case 'BATCH_PROCESS':
            return {
                ...state,
                batchProcess: action.data
            }
        case 'SUBSCRIPTION_PLANS':
            return {
                ...state,
                subscriptionPlans: action.data
            }
        case 'COUPAN_CODES':
            return {
                ...state,
                coupanCodes: action.data
            }
        case 'TEST_CONFIG':
            return {
                ...state,
                configs: action.data
            }
        case 'GET_EXAMCOVERED':
            return {
                ...state,
                examCovered: action.data
            }
        case 'TEST_SERIES':
            return {
                ...state,
                testSeries: action.data
            }
        case 'FETCH_TESTS':
            return {
                ...state,
                tests: action.data
            }

        case 'USER_SUBSCRIPTIONS':
            return {
                ...state,
                testSeriesSubscriptions: action.data.subscription,
                testPurchase: action.data.purchase
            }

        case 'DYNAMIC_TESTS':
            return {
                ...state,
                dynamicTests: action.data
            }

        case 'BOOKMARKED_TESTS':
            return {
                ...state,
                bookmarkedTests: action.data
            }

        case 'SWOT_TESTS':
            return {
                ...state,
                swotTests: action.data
            }

        case 'EXAMS_COVERED':
            return {
                ...state,
                examsCovered: action.data
            }

        case 'EXAMS_COVERED_LIST':
            return {
                ...state,
                examsList: action.data
            }

        case 'PREVIOUS_YEAR_TESTS':
            return {
                ...state,
                previousYearTests: action.data
            }

        case 'SET_USER_PROFILE':
            return {
                ...state,
                profile: action.data
            }

        case 'FETCH_LIVE_TESTS':
            return {
                ...state,
                liveTests: action.data,
                loading: false
            }
        case 'FETCH_ALL_LIVE_TESTS':
            return {
                ...state,
                allLiveTests: action.data,
                loading: false
            }
        case 'FETCH_LIVE_TEST_STATS':
            return {
                ...state,
                liveTestStats: action.data,
                statsLoading: false
            }

        case 'FETCH_LIVE_TESTS_REQUEST':
            return { ...state, loading: true, error: null };
        case 'FETCH_LIVE_TESTS_SUCCESS':
            return { ...state, loading: false, allLiveTests: action.payload };
        case 'FETCH_LIVE_TESTS_FAILURE':
            return { ...state, loading: false, error: action.payload };

        case 'FETCH_LIVE_TEST_STATS_REQUEST':
            return { ...state, statsLoading: true, statsError: null };
        case 'FETCH_LIVE_TEST_STATS_SUCCESS':
            return { ...state, statsLoading: false, liveTestStats: action.payload };
        case 'FETCH_LIVE_TEST_STATS_FAILURE':
            return { ...state, statsLoading: false, statsError: action.payload };

        // Home page data actions
        case 'FETCH_HOME_DATA_REQUEST':
            return { 
                ...state, 
                homeDataLoading: true, 
                homeDataError: null 
            };
        case 'FETCH_HOME_DATA_SUCCESS':
            return { 
                ...state, 
                homeDataLoading: false,
                homeTestSeries: action.payload.testSeries || [],
                homeExamsCovered: action.payload.examsCovered || [],
                homeDataLastFetched: Date.now(),
                homeDataError: null
            };
        case 'FETCH_HOME_DATA_FAILURE':
            return { 
                ...state, 
                homeDataLoading: false, 
                homeDataError: action.payload 
            };
        case 'CLEAR_HOME_DATA':
            return {
                ...state,
                homeTestSeries: [],
                homeExamsCovered: [],
                homeDataLastFetched: null,
                homeDataError: null
            };

        // Attempted tests actions
        case 'FETCH_ATTEMPTED_TESTS':
            return {
                ...state,
                attemptedTests: action.data,
                attemptedTestsLoading: false,
                attemptedTestsError: null
            };
        case 'FETCH_ATTEMPTED_TESTS_ERROR':
            return {
                ...state,
                attemptedTestsLoading: false,
                attemptedTestsError: action.payload
            };

        // Test analysis actions
        case 'FETCH_TEST_ANALYSIS_REQUEST':
            return {
                ...state,
                testAnalysisLoading: true,
                testAnalysisError: null
            };
        case 'FETCH_TEST_ANALYSIS_SUCCESS':
            return {
                ...state,
                testAnalysis: action.data,
                testAnalysisLoading: false,
                testAnalysisError: null
            };
        case 'FETCH_TEST_ANALYSIS_ERROR':
            return {
                ...state,
                testAnalysisLoading: false,
                testAnalysisError: action.payload
            };

        default:
            return state
    }
}

export default questionReducer
